<div
  id="main"
  [class]="sidebarService.contentSize$()"
  *ngIf="storesInitialized && userStore.commune()">
  <app-top-bar></app-top-bar>
  <app-toolbar backLink="data-backend" [toolbarItems]="toolbarItems">
  </app-toolbar>

  <div id="content" class="mt-7 pt-3 px-3 pb-6">
    <div class="grid">
      <div class="col-6">
        <div class="relative">
          <app-data-layer-type-administration />
        </div>
      </div>

      <div class="col-6">
        @if (globalStore.getFeatureCollectionFromSelection(); as geoData) {
          <app-basic-map
            [geoJsonData]="geoData"
            [showGlobalData]="true"
            [dataLayerType]="globalStore.selectedType()"></app-basic-map>
        } @else {
          <app-alert
            [severity]="globalStore.selectedGeoData() ? 'warning' : 'info'"
            styleClass="m-0 p-3 pt-1"
            [header]="
              globalStore.selectedGeoData()
                ? 'Geodaten noch nicht vorhanden'
                : 'Keine Geodaten vorhanden'
            "
            [canToggle]="false">
            @if (globalStore.selectedGeoData()) {
              <p>
                Für diesen Raum wurden über den Datenimport Platzhalter ohne
                Geometrien erzeugt.
              </p>
              <p>
                Laden Sie die passenden Geodaten nachträglich hoch, um eine
                Karte anzeigen zu können.
              </p>
            } @else {
              <p>
                Für die ausgewählte Betrachtungsebene wurden bisher keine
                Geodaten hinterlegt. Um Karten anzeigen zu können, müssen Sie
                Geodaten hochladen.
              </p>
            }
            <p class="flex gap-2">
              <p-button
                icon="fas fa-cloud-upload-alt"
                label="Geodaten hochladen"
                [rounded]="true"
                [routerLink]="[
                  '/data-backend',
                  {
                    outlets: {
                      overlay: [
                        'cloud',
                        {
                          outlets: {
                            panel: ['geo-daten'],
                          },
                        },
                      ],
                    },
                  },
                ]"></p-button>
              @if (
                !globalStore.selectedGeoData() &&
                globalStore.selectedLayer()?.type === 'Point'
              ) {
                <p-button
                  icon="fas fa-cloud-upload-alt"
                  label="Standorte hochladen"
                  [rounded]="true"
                  [routerLink]="[
                    '/data-backend',
                    {
                      outlets: {
                        overlay: [
                          'cloud',
                          {
                            outlets: {
                              panel: ['poi'],
                            },
                          },
                        ],
                      },
                    },
                  ]"></p-button>
              }
            </p>
          </app-alert>
        }
      </div>
    </div>

    <div class="grid">
      <div class="col-6">
        <app-indicator-detail />
      </div>

      <div class="col-6">
        <app-indicator-data-detail />
      </div>
    </div>

    @if (
      globalStore.selectedChildIndicator() || globalStore.selectedIndicator();
      as indicator
    ) {
      <div
        (click)="openDataList = !openDataList"
        [class.fixed-bottom-content-slide--open]="openDataList"
        [style]="{ 'z-index': 500 }"
        class="z-overlay fixed-bottom-content-slide fixed right-0 shadow-4 surface-0 p-3 hover:shadow-8">
        <div class="border-arrow surface-0"></div>

        <app-header
          styleClass="m-0 mb-4"
          [icon]="
            activeIndicatorData
              ? activeIndicatorData?.published
                ? 'fas fa-earth-europe'
                : 'fas fa-lock'
              : 'fas fa-file-text'
          "
          [text]="'Daten in ' + indicatorStore.getFullName(indicator)" />
        <app-indicator-data-list
          [dataPublicationMode]="true"
          [indicator]="indicator"></app-indicator-data-list>
      </div>

      @if (openDataList) {
        <app-mask (click)="openDataList = false" />
      }
    }
  </div>
</div>

<p-confirmDialog></p-confirmDialog>

<app-confirm-delete-indicator
  *ngIf="indicatorStore.selectedItem() as selectedIndicator"
  [indicator]="selectedIndicator" />

<app-confirm-delete-category />
<app-confirm-delete-data-layer />
<app-confirm-publication-data-layer />
<app-confirm-publish-data />
<app-confirm-delete-data-layer-type />
<app-confirm-delete-bookmark-category />
<app-confirm-delete-bookmark-link />
<app-confirm-disable-bookmark-link />

<p-sidebar
  *ngIf="routingService.showSidebarByRoute('root') as showSidebar"
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-8'"
  [visible]="showSidebar">
  <ng-template pTemplate="header">
    <app-header
      [icon]="routingService.getEditFormOverlayIcon()"
      [text]="routingService.getEditFormOverlayHeader()"></app-header
  ></ng-template>
  <router-outlet name="bearbeiten"></router-outlet>
</p-sidebar>

@if (globalStore.availableHelpByRoute(); as key) {
  <div class="fixed bottom-0 right-0 z-5">
    <app-help-button [key]="key" />
  </div>
}

<p-dialog
  styleClass="z-top"
  maskStyleClass="z-top"
  appendTo="body"
  [(visible)]="!!addNewLayerDialogWithType"
  [style]="{ width: '48rem' }">
  <ng-template pTemplate="header">
    <app-header
      styleClass="m-0"
      icon="fas fa-plus-circle"
      text="Jahr hinzufügen"></app-header>
  </ng-template>
  @if (addNewLayerDialogWithType) {
    <app-data-layer-form
      [cancelLevel]="0"
      [disableCancelLink]="true"
      [parentId]="addNewLayerDialogWithType"
      (formSubmitted)="
        addNewLayerDialogWithType = undefined
      "></app-data-layer-form>
  }
</p-dialog>

<p-dialog
  styleClass="z-top"
  maskStyleClass="z-top"
  appendTo="body"
  [(visible)]="addNewBookmarkCategoryDialog"
  [style]="{ width: '40rem' }">
  <ng-template pTemplate="header">
    <app-header
      styleClass="m-0"
      icon="fas fa-plus-circle"
      text="Ordner hinzufügen"></app-header>
  </ng-template>
  @if (addNewBookmarkCategoryDialog) {
    <app-bookmark-category-form
      [disableCancelLink]="true"
      [cancelLevel]="0"
      (formSubmitted)="
        addNewBookmarkCategoryDialog = false
      "></app-bookmark-category-form>
  }
</p-dialog>

<p-dialog
  styleClass="z-top"
  maskStyleClass="z-top"
  appendTo="body"
  [(visible)]="addNewColorsetDialog"
  [style]="{ width: '80rem' }">
  <ng-template pTemplate="header">
    <app-header
      styleClass="m-0"
      icon="fas fa-plus-circle"
      text="Farbset hinzufügen"></app-header>
  </ng-template>
  @if (addNewColorsetDialog) {
    <app-colorset-form
      [disableCancelLink]="true"
      [cancelLevel]="0"
      (formSubmitted)="addNewColorsetDialog = false"></app-colorset-form>
  }
</p-dialog>

<p-dialog
  styleClass="z-top"
  maskStyleClass="z-top"
  appendTo="body"
  [(visible)]="!!addWorkspaceDialog"
  [style]="{ width: '40rem' }">
  <ng-template pTemplate="header">
    <app-header
      styleClass="m-0"
      icon="fas fa-plus-circle"
      text="Arbeitsbereich hinzufügen"></app-header>
  </ng-template>
  @if (!!addWorkspaceDialog) {
    <app-workspace-form
      [type]="this.addWorkspaceDialog || undefined"
      [cancelLevel]="0"
      (cancel)="addWorkspaceDialog = ''"
      (formSubmitted)="addWorkspaceDialog = ''"></app-workspace-form>
  }
</p-dialog>
